import { render, staticRenderFns } from "./TranslationsManager.vue?vue&type=template&id=3fbbb922&scoped=true&"
import script from "./TranslationsManager.vue?vue&type=script&lang=js&"
export * from "./TranslationsManager.vue?vue&type=script&lang=js&"
import style0 from "./TranslationsManager.vue?vue&type=style&index=0&id=3fbbb922&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbbb922",
  null
  
)

export default component.exports